(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /* Helpers                                                             */
  /* ------------------------------------------------------------------ */
  function qs(selector, root) { return (root || document).querySelector(selector); }
  function qsa(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }

  // Adds/replaces a `width` query param on a Shopify CDN image URL.
  function resizeImage(url, width) {
    if (!url) return url;
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width', width);
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  // Formats an integer cent amount using the shop's money_format
  // (exposed as window.themeMoneyFormat by layout/theme.liquid).
  function formatMoney(cents, format) {
    format = format || window.themeMoneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimals = parts[0];
    var withComma = parts.join(',');
    var withDot = parts.join('.');
    return format
      .replace(/\{\{\s*amount\s*\}\}/, withDot)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma);
  }

  /* ------------------------------------------------------------------ */
  /* Mobile nav toggle                                                   */
  /* ------------------------------------------------------------------ */
  function initNavToggle() {
    var toggle = qs('[data-nav-toggle]');
    var nav = qs('[data-site-nav]');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      var isOpen = nav.hasAttribute('data-open');
      if (isOpen) {
        nav.removeAttribute('data-open');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        nav.setAttribute('data-open', '');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });

    qsa('.site-nav__link', nav).forEach(function (link) {
      link.addEventListener('click', function () {
        nav.removeAttribute('data-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Header height CSS var — keeps the sticky shop sidebar's offset      */
  /* accurate even if the logo/font size changes the header's height.    */
  /* ------------------------------------------------------------------ */
  function initHeaderHeightVar() {
    var header = qs('[data-site-header]');
    if (!header) return;

    function update() {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    }

    update();
    window.addEventListener('resize', update);
  }

  /* ------------------------------------------------------------------ */
  /* Mobile category dropdown — collapses the shop sidebar's link list   */
  /* into a tap-to-open panel instead of a wall of wrapped pills.        */
  /* ------------------------------------------------------------------ */
  function initShopSidebarToggle() {
    qsa('[data-shop-sidebar]').forEach(function (sidebar) {
      var toggle = qs('[data-shop-sidebar-toggle]', sidebar);
      var list = qs('[data-shop-sidebar-list]', sidebar);
      var currentLabel = qs('[data-shop-sidebar-current]', toggle);
      if (!toggle || !list) return;

      var activeLink = qs('.shop-sidebar__link.is-active', list);
      if (activeLink && currentLabel) currentLabel.textContent = activeLink.textContent.trim();

      function close() {
        sidebar.removeAttribute('data-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
      function open() {
        sidebar.setAttribute('data-open', '');
        toggle.setAttribute('aria-expanded', 'true');
      }

      toggle.addEventListener('click', function (event) {
        event.stopPropagation();
        if (sidebar.hasAttribute('data-open')) close(); else open();
      });

      document.addEventListener('click', function (event) {
        if (sidebar.hasAttribute('data-open') && !sidebar.contains(event.target)) close();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') close();
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Hero slideshow — autoplays, changes every N ms (default 3000)       */
  /* ------------------------------------------------------------------ */
  function initHeroSlideshow(root) {
    var slides = qsa('[data-hero-slide]', root);
    if (slides.length < 1) return;

    var interval = parseInt(root.getAttribute('data-interval'), 10) || 3000;
    var current = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    if (current < 0) current = 0;
    var timer = null;

    function show(index) {
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      slides[current].removeAttribute('aria-hidden');
    }

    function next() { show(current + 1); }
    function prev() { show(current - 1); }

    function start() {
      if (slides.length < 2) return;
      stop();
      timer = window.setInterval(next, interval);
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    var prevBtn = qs('[data-hero-prev]', root);
    var nextBtn = qs('[data-hero-next]', root);
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); start(); });

    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!prefersReducedMotion) start();
  }

  /* ------------------------------------------------------------------ */
  /* Client-side "Load more" — used only by the All grid, which renders  */
  /* every card up front in a hand-built category order Shopify's        */
  /* {% paginate %} tag can't reproduce, so there's nothing to fetch     */
  /* from the server; this just progressively reveals more of what's     */
  /* already in the DOM.                                                 */
  /* ------------------------------------------------------------------ */
  function initClientPaginate(grid) {
    var pageSize = parseInt(grid.getAttribute('data-page-size'), 10) || 12;
    var cards = qsa('.product-card', grid);
    var sentinel = grid.parentElement ? qs('[data-client-paginate-sentinel]', grid.parentElement) : null;
    var button = sentinel ? qs('[data-client-load-more]', sentinel) : null;
    var shown = pageSize;

    function apply() {
      cards.forEach(function (card, i) { card.hidden = i >= shown; });
      if (button) button.hidden = shown >= cards.length;
    }

    apply();

    if (button) {
      button.addEventListener('click', function () {
        shown += pageSize;
        apply();
      });
    }
  }

  /* ------------------------------------------------------------------ */
  /* Infinite scroll — replaces numbered pagination on product grids.    */
  /* A "Load more" button is always present (works with JS off entirely  */
  /* disabled and is keyboard/screen-reader friendly); when              */
  /* IntersectionObserver is available it also auto-triggers as soon as  */
  /* the button scrolls into view, so it reads as true infinite scroll.  */
  /* ------------------------------------------------------------------ */
  function initInfiniteScrollContainer(container) {
    var sectionId = container.getAttribute('data-section-id');
    var baseUrl = container.getAttribute('data-base-url');
    var grid = qs('[data-product-grid]', container);
    var observer = null;

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) loadNext(entry.target);
          });
        },
        { rootMargin: '600px 0px' }
      );
    }

    function wire(sentinel) {
      if (!sentinel) return;
      var hasNext = sentinel.getAttribute('data-has-next') === 'true';
      if (!hasNext) return;
      var button = qs('[data-load-more]', sentinel);
      if (button) button.addEventListener('click', function () { loadNext(sentinel); });
      if (observer) observer.observe(sentinel);
    }

    function loadNext(sentinel) {
      if (sentinel.hasAttribute('data-loading')) return;
      sentinel.setAttribute('data-loading', '');
      if (observer) observer.unobserve(sentinel);

      var button = qs('[data-load-more]', sentinel);
      if (button) {
        button.disabled = true;
        button.textContent = 'Loading…';
      }

      var nextPage = sentinel.getAttribute('data-next-page');
      var separator = baseUrl.indexOf('?') > -1 ? '&' : '?';
      var url = baseUrl + separator + 'page=' + nextPage + '&section_id=' + sectionId;

      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-product-grid]');
          var newSentinel = doc.querySelector('[data-infinite-scroll-sentinel]');

          if (newGrid) {
            // Snapshot to a static array first: newGrid.children is a live
            // HTMLCollection, and appendChild() below removes each card from
            // it as we move it, which reindexes the live list mid-iteration
            // and silently skips every other card.
            var cards = Array.prototype.slice.call(newGrid.children);
            cards.forEach(function (card) {
              grid.appendChild(card);
            });
          }

          sentinel.remove();
          if (newSentinel) {
            container.appendChild(newSentinel);
            wire(newSentinel);
          }
        })
        .catch(function () {
          sentinel.removeAttribute('data-loading');
          if (button) {
            button.disabled = false;
            button.textContent = 'Load more';
          }
        });
    }

    wire(qs('[data-infinite-scroll-sentinel]', container));
  }

  /* ------------------------------------------------------------------ */
  /* Scrollspy — highlights "Shop" in the header nav once the home page's */
  /* embedded shop section scrolls into view, and "Home" otherwise.      */
  /* ------------------------------------------------------------------ */
  function initScrollspy() {
    var shopSection = qs('[data-scrollspy-section="shop"]');
    if (!shopSection) return;

    var homeLink = qs('[data-nav-key="home"]');
    var shopLink = qs('[data-nav-key="shop"]');
    if (!homeLink || !shopLink) return;

    var header = qs('[data-site-header]');
    var ticking = false;

    function update() {
      ticking = false;
      var headerHeight = header ? header.offsetHeight : 0;
      var triggerLine = headerHeight + 10;
      var isPastHero = shopSection.getBoundingClientRect().top <= triggerLine;
      shopLink.classList.toggle('is-active', isPastHero);
      homeLink.classList.toggle('is-active', !isPastHero);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ------------------------------------------------------------------ */
  /* Product page — variant selection: swap image, price, availability   */
  /* ------------------------------------------------------------------ */
  function initProductForm(section) {
    var dataEl = qs('[data-product-json]', section);
    if (!dataEl) return;

    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var optionInputs = qsa('[data-product-option-input]', section);
    var variantIdInput = qs('[data-product-variant-id]', section);
    var priceEl = qs('[data-product-price]', section);
    var availabilityEl = qs('[data-product-availability]', section);
    var submitBtn = qs('[data-product-submit]', section);
    var submitText = qs('[data-product-submit-text]', section);
    var mainImage = qs('[data-product-main-image]', section);
    var thumbs = qsa('[data-product-thumb]', section);

    function selectedOptions() {
      var values = [];
      qsa('[data-product-option]', section).forEach(function (fieldset) {
        var index = parseInt(fieldset.getAttribute('data-option-index'), 10);
        var checked = qs('input[data-product-option-input]:checked', fieldset);
        values[index] = checked ? checked.value : null;
        var display = qs('[data-selected-option-value]', fieldset);
        if (display && checked) display.textContent = checked.value;
      });
      return values;
    }

    function findVariant(values) {
      return product.variants.find(function (variant) {
        return values.every(function (value, index) { return variant.options[index] === value; });
      });
    }

    function setActiveThumb(mediaId) {
      thumbs.forEach(function (thumb) {
        var isMatch = String(thumb.getAttribute('data-media-id')) === String(mediaId);
        thumb.classList.toggle('is-active', isMatch);
      });
    }

    function applyVariant(variant) {
      if (!variant) return;

      if (variantIdInput) variantIdInput.value = variant.id;

      if (priceEl) {
        var formatted = formatMoney(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var compareFormatted = formatMoney(variant.compare_at_price);
          priceEl.innerHTML = '<span class="product__price--sale">' + formatted + '</span> <s class="product__price--compare">' + compareFormatted + '</s>';
        } else {
          priceEl.textContent = formatted;
        }
      }

      if (availabilityEl) availabilityEl.textContent = variant.available ? 'In stock' : 'Sold out';

      if (submitBtn) submitBtn.disabled = !variant.available;
      if (submitText) submitText.textContent = variant.available ? 'Add to cart' : 'Sold out';

      // The core ask: switching color (e.g. selecting Green) swaps the
      // product image immediately, no reload, no waiting on the server.
      if (variant.featured_image && mainImage) {
        mainImage.src = resizeImage(variant.featured_image.src, 1200);
        // srcset takes priority over src in every browser when both are
        // present — leaving the old srcset in place meant the browser kept
        // rendering the previous color no matter what src was updated to.
        mainImage.srcset = [600, 1200, 1800]
          .map(function (w) { return resizeImage(variant.featured_image.src, w) + ' ' + w + 'w'; })
          .join(', ');
        mainImage.alt = variant.featured_image.alt || product.title;
        setActiveThumb(variant.featured_media_id);
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var variant = findVariant(selectedOptions());
        applyVariant(variant);
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImage) {
          mainImage.src = thumb.getAttribute('data-full-src');
          // Same reasoning as above: an untouched srcset would silently
          // override this src change, so it has to be cleared here too.
          mainImage.srcset = '';
        }
        setActiveThumb(thumb.getAttribute('data-media-id'));
      });
    });

    // Add to cart via AJAX so selecting a variant + adding never reloads the page.
    var form = qs('[data-product-form]', section);
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (submitBtn) submitBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantIdInput.value, quantity: 1 }),
        })
          .then(function (res) { return res.json(); })
          .then(function (item) {
            updateCartCount();
            openCartDrawer(item);
          })
          .catch(function () {
            form.submit();
          })
          .finally(function () {
            var variant = findVariant(selectedOptions());
            if (submitBtn) submitBtn.disabled = variant ? !variant.available : false;
          });
      });
    }
  }

  /* ------------------------------------------------------------------ */
  /* Cart count + drawer                                                 */
  /* ------------------------------------------------------------------ */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        qsa('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      });
  }

  function openCartDrawer(item) {
    var drawer = qs('[data-cart-drawer]');
    if (!drawer) return;
    var itemEl = qs('[data-cart-drawer-item]', drawer);
    if (itemEl && item) {
      itemEl.innerHTML =
        (item.image ? '<img src="' + resizeImage(item.image, 200) + '" alt="">' : '') +
        '<div><p class="cart-item__title">' + item.product_title + '</p>' +
        (item.variant_title ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '') +
        '</div>';
    }
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    var drawer = qs('[data-cart-drawer]');
    if (!drawer) return;
    drawer.hidden = true;
    document.body.style.overflow = '';
  }

  function initCartDrawer() {
    qsa('[data-cart-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeCartDrawer);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeCartDrawer();
    });
  }

  /* ------------------------------------------------------------------ */
  /* Init                                                                 */
  /* ------------------------------------------------------------------ */
  function init() {
    document.documentElement.classList.remove('no-js');

    initNavToggle();
    initScrollspy();
    initCartDrawer();
    initHeaderHeightVar();
    initShopSidebarToggle();

    qsa('[data-hero-slideshow]').forEach(initHeroSlideshow);
    qsa('[data-product-section]').forEach(initProductForm);
    qsa('[data-infinite-scroll]').forEach(initInfiniteScrollContainer);
    qsa('[data-client-paginate]').forEach(initClientPaginate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init affected widgets when merchant edits sections in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    var hero = qs('[data-hero-slideshow]', event.target);
    if (hero) initHeroSlideshow(hero);
    var product = qs('[data-product-section]', event.target);
    if (product) initProductForm(product);
  });
})();
